import type { DsrResource } from '@getaccept/lib-shared/src/library/types/dsr-resource';
import { SortOrder } from '@getaccept/fried-tofu';
import type { Filter } from '@getaccept/lib-shared/src/library/types/filter';
import { SortAttribute } from '@getaccept/lib-shared/src/library/types/enums/sort-attribute';
import { DsrResourceType } from '@getaccept/lib-shared/src/library/types/enums/dsr-resource-type';

export class LibraryConstants {
  static pageSize = 15;
  static searchHistoryIdentifierKey = 'library';

  static placeholderResource: DsrResource = {
    id: null,
    title: null,
    resourceType: null,
    contentId: null,
    access: null,
    directory: null,
    createdAt: null,
    updatedAt: null,
    statistics: null,
  };

  static defaultFilter: Filter = {
    resourceType: DsrResourceType.All,
    directory: '',
    searchTerm: '',
    sortBy: SortAttribute.CreatedAt,
    sortOrder: SortOrder.Desc,
    offset: 0,
    tagIds: [],
  };
}
